import { Toast } from "bootstrap";

let allToast: (Toast | undefined)[] = [];

export const useSimpleToast = (option?: Partial<Toast.Options>) => {
  type ToastType = "info" | "warning" | "danger" | "success";

  let toastOption: Toast.Options = {
    animation: true,
    autohide: true,
    delay: 5000,
  };

  if (option) {
    toastOption = { ...toastOption, ...option };
  }

  const getContainer = () => {
    const containerId = "toast-container-top-middle";
    let container = document.getElementById(containerId);

    if (!container) {
      container = document.createElement("div");
      container.id = containerId;
      container.style.top = "4.5rem";
      container.style.zIndex = "2000";
      container.classList.add("toast-container");
      container.classList.add("position-fixed");
      container.classList.add("start-50");
      container.classList.add("translate-middle-x");
      container.classList.add("user-select-none");
      document.body.appendChild(container);
    }

    return container;
  };

  const createToastDom = (option: { message: string; type: ToastType }) => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("toast");
    wrapper.classList.add("show");
    wrapper.classList.add("align-items-center");

    if (option.type === "warning") {
      wrapper.classList.add("text-white");
      wrapper.classList.add("bg-warning");
    } else if (option.type === "danger") {
      wrapper.classList.add("text-white");
      wrapper.classList.add("bg-danger");
    } else if (option.type === "success") {
      wrapper.classList.add("text-white");
      wrapper.classList.add("bg-success");
    }

    wrapper.setAttribute("role", "alert");
    wrapper.setAttribute("aria-live", "assertive");
    wrapper.setAttribute("aria-atomic", "true");
    wrapper.innerHTML = `
      <div class="d-flex justify-content-between">
        <div class="toast-body flex-fill">${option.message}</div>
        <button type="button" class="btn-close m-auto pe-16 ps-16" data-bs-dismiss="toast" aria-label="Close">
        </button>
      </div>
    `;
    return wrapper;
  };

  const addHiddenEventListener = (dom: Element, toast: Toast) => {
    const container = getContainer();
    dom.addEventListener("hidden.bs.toast", () => {
      allToast.forEach((item, index) => {
        if (toast === item) {
          allToast[index] = undefined;
        }
      });
      toast.dispose();
      container.removeChild(dom);
    });
  };

  const closeAllToast = () => {
    const tmpToast = allToast;
    tmpToast.map((toast) => {
      toast?.hide && toast.hide();
    });
    allToast = [];
  };

  const deleteAllToast = () => {
    const container = getContainer();
    if (container.innerHTML) {
      container.innerHTML = "";
    }
    allToast = [];
  };

  const showToast = (
    type: ToastType,
    message: string,
    option?: Partial<Toast.Options>
  ) => {
    const newOption = option ? { ...toastOption, ...option } : option;
    const container = getContainer();
    const toastDom = createToastDom({ type, message });
    const toast = new Toast(toastDom, newOption);
    allToast.push(toast);
    addHiddenEventListener(toastDom, toast);
    container?.append(toastDom);
    toast.show();
    return toast;
  };

  const showInfoToast = (message: string, option?: Partial<Toast.Options>) => {
    return showToast("info", message, option);
  };

  const showSuccessToast = (
    message: string,
    option?: Partial<Toast.Options>
  ) => {
    return showToast("success", message, option);
  };

  const showDangerToast = (
    message: string,
    option?: Partial<Toast.Options>
  ) => {
    return showToast("danger", message, option);
  };

  const showWarningToast = (
    message: string,
    option?: Partial<Toast.Options>
  ) => {
    return showToast("warning", message, option);
  };

  return {
    showInfoToast,
    showDangerToast,
    showWarningToast,
    showSuccessToast,
    closeAllToast,
    deleteAllToast,
  };
};
